<template>
  <a
    href="#"
    class="launcher-button"
    title="Order Now!"
    @click.prevent="showOrderSystem"
    :style="inlineStyles"
  >
    <span class="badge">1</span>
    <FoodTraySvg v-if="!launcherIcon" class="food-tray" />
  </a>
</template>

<script>
import FoodTraySvg from "@/assets/svgs/food-tray.svg";
import PostMessages from "@/services/PostMessages";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    FoodTraySvg
  },
  computed: {
    ...mapGetters({
      state: "getState",
      themeColor: "getThemeColor",
      launcherIcon: "getLauncherIcon"
    }),
    inlineStyles() {
      let styles = "";

      if (this.themeColor) {
        styles += `background-color: ${this.themeColor};`;
      }

      if (this.launcherIcon) {
        styles += `background-image: url(${this.launcherIcon});`;
      }

      return styles;
    }
  },
  async created() {
    await this.getBusiness();
    this.launchWidget();
  },
  methods: {
    ...mapActions({
      setBusiness: "setBusiness"
    }),
    async getBusiness() {
      try {
        const info = await axios.get(
          `${process.env.VUE_APP_API_LINK}/storefront/v2/businesses/${this.$route.params.slug}/widget`
        );

        info.data.widget_type = info.data.type;
        info.data.url = info.data.business_url;

        delete info.data.type;
        delete info.data.business_url;

        await this.setBusiness(info.data);
        this.emitMessage("shareWidgetState", this.state);
      } catch (e) {
        window.console.log(e.response);
      }
    },
    showOrderSystem() {
      this.emitMessage("showOrderSystem");
    },
    launchWidget() {
      this.emitMessage("launchWidget");
    },
    emitMessage(event, data = null) {
      const messages = new PostMessages(event, data);
      messages.send();
    }
  }
};
</script>

<style lang="scss" scoped>
.launcher-button {
  cursor: pointer;
  border-radius: 0.3125rem;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
  display: inline-block;
  width: 55px;
  height: 55px;
  background-position: center;
  background-size: cover;
  background-color: #007bff;
  position: relative;
  margin: 10px 10px 0 0;
  padding: 0.3rem;

  animation-name: scale-up;
  animation-duration: 0.3s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;

  .food-tray {
    fill: #ffffff;
  }

  .badge {
    display: flex;
    width: 23px;
    height: 23px;
    font-size: 0.75rem;
    font-weight: 700;
    border-radius: 100%;
    border: 2px solid #fff;
    background-color: #ff001f;
    color: #fff;
    position: absolute;
    top: -10px;
    right: -10px;
    justify-content: center;
    align-items: center;
  }
}

@keyframes scale-up {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
</style>
